export const defaultLocale = 'ru';
export const locales = [
  'en',
  'ru',
  'kk',
  'uz',
  'az',
  'ky',
  'tr',
  'ka',
  'de',
  'es',
  'pt',
];

export type Locale = (typeof locales)[number];
